import React, { useState } from "react";
import { Link } from "react-router-dom";
import { iconoMayorista } from "../assets/landing";

const discountLevels = [
  { discount: "5%", label: "NIVEL 1", range: "4-15 UNIDADES", tone: "bg-[#f1f8ef]" },
  { discount: "10%", label: "NIVEL 2", range: "16-30 UNIDADES", tone: "bg-[#e8f8e1]" },
  {
    discount: "15%",
    label: "NIVEL 3",
    range: "31-50 UNIDADES",
    tone: "bg-[#dcf7d4]",
    badge: "MÁS POPULAR",
  },
  {
    discount: "20%",
    label: "NIVEL 4",
    range: "51 O MÁS UNIDADES",
    tone: "bg-[#1e1e1e]",
    dark: true,
    badge: "Máximo beneficio",
  },
];

const steps = [
  {
    number: "1",
    title: "Solicitas tu propuesta",
    description: "Llenas el formulario con tus datos y lo que necesitas. Toma 2 minutos.",
  },
  {
    number: "2",
    title: "Te contactamos en 24h",
    description: "Te armamos una propuesta con precios y descuento según las cantidades que necesites.",
  },
  {
    number: "3",
    title: "¡Eres cliente Omova!",
    description: "Tras tu primera compra, recibes acceso a la plataforma exclusiva para autocotizar 24/7.",
  },
];

const benefits = [
  {
    icon: "discount",
    title: "DESCUENTOS POR VOLUMEN",
    description: "5% a 20% según el total de unidades. Fibras, resinas y flakes suman juntos.",
  },
  {
    icon: "advisor",
    title: "ASESOR DEDICADO",
    description: "Una persona, no un chat genérico. Te ayuda a calcular material, surtir y resolver pedidos.",
  },
  {
    icon: "stock",
    title: "STOCK PRIORIZADO",
    description: "Desde 1 metro hasta rollos completos de 100 m. Si lo necesitas en otro corte, lo cotizamos.",
  },
  {
    icon: "quote",
    title: "COTIZACIÓN 24/7",
    description: "Cotiza, ordena y descarga tus facturas cuando quieras. Sin esperar horario comercial.",
  },
];

const testimonials = [
  {
    quote:
      '"Empecé con 2 m² de prueba. Hoy pido pedidos grandes cada mes. La diferencia con mi proveedor anterior es que aquí me responden el mismo día y la atención es mejor."',
    initials: "JM",
    name: "José M.",
    role: "Taller de personalización · CDMX",
    color: "bg-[#39bf42]",
  },
  {
    quote:
      '"Pedí ficha técnica antes de cambiar de resina. Me la mandaron sin pretextos y la calidad es buena. Llevo 8 meses comprando aquí."',
    initials: "DG",
    name: "Diego G.",
    role: "Fabricante de piezas · Querétaro",
    color: "bg-[#1650c5]",
  },
];

const faqs = [
  {
    title: "¿Por qué confiar en Omova Carbon Fiber?",
    content:
      "Las unidades se acumulan en cada pedido. m² de fibra, kg de resina y botes de flakes cuentan igual: 1 unidad cada uno. El descuento se aplica al total del pedido según el nivel alcanzado.",
  },
  {
    title: "¿Cómo hacer mi primer pedido?",
    content:
      "Llena el formulario y cuéntanos qué necesitas. En menos de 24 h un asesor te compartirá una propuesta personalizada. Confirmas, pagas por transferencia o tarjeta, y lo enviamos. Tras tu primera compra te damos acceso a la plataforma para ordenar por tu cuenta.",
  },
  {
    title: "¿Por qué mi compra es segura?",
    content:
      "Trabajamos con datos claros, seguimiento de pedido, factura y atención humana. Antes de surtir, confirmamos contigo cualquier detalle importante.",
  },
  {
    title: "¿Cómo envían mis productos?",
    content:
      "Enviamos a todo México con guía de rastreo. El tiempo exacto depende de tu ubicación, pero te mantenemos actualizado en cada paso.",
  },
  {
    title: "¿Cómo funcionan los niveles de descuento mayorista?",
    content:
      "Cada pedido suma unidades entre fibra, resina y flakes. Cuando alcanzas un nivel, el descuento se calcula sobre el total del pedido, no sólo sobre un producto.",
  },
];

const stats = [
  { value: "20%", label: "DESCUENTO MÁX." },
  { value: "+50", label: "NEGOCIOS ACTIVOS" },
  { value: "24h", label: "RESPUESTA" },
];

const BenefitGlyph = ({ icon }) => {
  if (icon === "discount") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 stroke-current" fill="none" strokeWidth="1.8">
        <path d="M4 12h7" />
        <path d="M9 7H7a3 3 0 1 0 0 6h2a3 3 0 1 1 0 6H4" />
        <path d="M18 5l2 2-8 8-3 1 1-3 8-8Z" />
      </svg>
    );
  }

  if (icon === "advisor") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 stroke-current" fill="none" strokeWidth="1.8">
        <path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
        <path d="M5 20a7 7 0 0 1 14 0" />
        <path d="M18 8h3" />
        <path d="M19.5 6.5v3" />
      </svg>
    );
  }

  if (icon === "stock") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 stroke-current" fill="none" strokeWidth="1.8">
        <path d="m12 3 8 4.5v9L12 21 4 16.5v-9L12 3Z" />
        <path d="m4 7.5 8 4.5 8-4.5" />
        <path d="M12 12v9" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 stroke-current" fill="none" strokeWidth="1.8">
      <path d="M4 5h16v11H7l-3 3V5Z" />
      <path d="M8 9h8" />
      <path d="M8 12h5" />
    </svg>
  );
};

const DesktopFaqItem = ({ item, open, onToggle }) => (
  <div className="border-b border-black/10 pb-4">
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-start justify-between gap-4 text-left"
      aria-expanded={open}
    >
      <span className="text-[1.02rem] font-semibold leading-tight text-[#2b2b2b]">{item.title}</span>
      <span className={`mt-1 shrink-0 text-xs text-[#2b2b2b] transition-transform ${open ? "rotate-180" : ""}`}>▲</span>
    </button>
    {open && (
      <p className="mt-3 max-w-[640px] text-[0.98rem] leading-[1.65] text-[#707070]">
        {item.content}
      </p>
    )}
  </div>
);

const FaqAccordion = ({ item, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="overflow-hidden rounded-[6px] bg-black text-white shadow-[0_1px_2px_rgba(0,0,0,0.18)]">
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left md:px-5 md:py-3"
        aria-expanded={open}
      >
        <span className="text-[0.82rem] font-black leading-tight md:text-base">{item.title}</span>
        <span
          className={`shrink-0 text-[0.85rem] transition-transform ${open ? "rotate-180 text-primary-green" : "text-white"}`}
        >
          ▲
        </span>
      </button>
      {open && (
        <div className="px-3 pb-3 text-[0.8rem] leading-[1.15] text-white/85 md:px-5 md:pb-4 md:text-base">
          {item.content}
        </div>
      )}
    </div>
  );
};

const Mayorista = () => {
  const [desktopFaqOpenIndex, setDesktopFaqOpenIndex] = useState(0);

  return (
    <main className="bg-[#f4f4ef] text-[#181818]">
      <section className="bg-[radial-gradient(circle_at_top,#162126_0%,#10191d_50%,#0a1012_100%)] px-5 pb-5 pt-4 text-white md:px-8 md:pb-14 md:pt-20">
        <div className="mx-auto max-w-[1280px] text-left">
          <div className="md:grid md:grid-cols-[minmax(0,1fr)_minmax(440px,544px)] md:items-center md:gap-14 lg:gap-20">
            <div className="max-w-[620px] text-left">
              <div className="inline-flex justify-start rounded-lg bg-[#1f6b29] px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.08em] text-primary-green md:px-4 md:py-2 md:text-[0.72rem] md:tracking-[0.22em]">
              Programa mayorista
              </div>
              <h1 className="mt-2.5 max-w-[320px] text-[1.62rem] font-black leading-[0.97] tracking-[-0.03em] md:mt-5 md:max-w-[430px] md:text-[3.1rem] md:leading-[1.04] md:tracking-[-0.045em] lg:text-[3.35rem]">
                Tu proveedor directo de fibra de carbono.
              </h1>
              <p className="mt-2.5 max-w-[330px] text-[0.8rem] leading-snug text-white/78 md:mt-3 md:max-w-[405px] md:text-[1rem] md:leading-[1.55] md:text-white/70">
                Para talleres, fabricantes y grandes proyectos.
              </p>

              <div className="mt-4 flex flex-col items-start md:mt-8">
                <div className="grid w-full max-w-[330px] grid-cols-3 divide-x divide-white/20 px-0 py-1 md:max-w-[430px] md:py-0">
                  {stats.map((stat, index) => (
                    <div
                      key={stat.label}
                      className={`px-2 py-2 text-left md:py-2 ${index === 0 ? "md:pr-6" : "md:px-6"}`}
                    >
                      <div className="text-[1.42rem] font-black leading-none text-primary-green md:text-[1.95rem]">{stat.value}</div>
                      <div className="mt-1 text-[9px] font-medium leading-tight tracking-[0.01em] text-primary-green/90 md:text-[0.78rem] md:leading-[1.2] md:text-white/42">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>

                <Link
                  to="/form"
                  className="mt-4 inline-flex w-full max-w-[300px] items-center justify-center self-start rounded-lg bg-primary-green px-5 py-3 text-[0.95rem] font-black uppercase text-black transition hover:brightness-105 md:mt-8 md:max-w-[620px] md:justify-between md:rounded-[10px] md:px-8 md:py-3.5 md:text-[1rem] md:normal-case"
                >
                  <span className="md:flex-1 md:text-center">Quiero ser mayorista</span>
                  <span className="ml-3 md:ml-6">→</span>
                </Link>

                <p className="mt-2.5 w-full max-w-[300px] self-start text-left text-[0.78rem] font-semibold text-primary-green md:mt-3 md:max-w-[620px] md:text-[0.86rem] md:font-medium md:text-white/34">
                  Sin costo · 2 minutos · Te contactamos en 24h
                </p>
              </div>
            </div>

            <div className="hidden md:flex md:items-center md:justify-end">
              <div className="flex h-[250px] w-full max-w-[580px] items-center justify-center">
                <img
                  src={iconoMayorista}
                  alt="Programa mayorista"
                  className="h-full w-full object-contain scale-110"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#f6f5ef] px-4 pb-8 pt-5 md:px-8 md:pb-14 md:pt-12">
        <div className="mx-auto max-w-[1280px]">
          <div className="max-w-[325px] md:hidden">
            <p className="text-[10px] font-black uppercase tracking-[0.16em] text-primary-green md:text-sm">
              Cómo funciona el descuento
            </p>
            <h2 className="mt-1 text-[1.82rem] font-black leading-[0.98] tracking-[-0.03em] text-[#171717] md:text-5xl">
              Más unidades, <span className="text-primary-green">mejor precio.</span>
            </h2>
            <p className="mt-2 max-w-[320px] text-[0.9rem] leading-[1.2] text-[#4b4b4b] md:max-w-[610px] md:text-xl">
              Las unidades se cuentan por todo lo que pidas: m² de fibra, kg de resina y botes de flakes. Todo suma.
            </p>

            <div className="mt-3 rounded-[12px] bg-[#eef8e9] px-3 py-3 text-left text-[#1a1a1a] md:px-5 md:py-4">
              <div className="border-l-[4px] border-primary-green pl-3 text-left">
                <p className="text-xs font-black uppercase tracking-wide text-primary-green md:text-sm">
                  Ejemplo real
                </p>
                <p className="mt-0.5 text-[0.9rem] leading-[1.2] md:text-lg">
                  8m² de fibra + 4kg de resina + 4 botes de flakes =
                </p>
                <p className="text-[0.9rem] font-black leading-[1.2] md:text-2xl">
                  16 unidades = Nivel 2 <span className="text-primary-green">(10% dto.)</span>
                </p>
              </div>
            </div>

            <div className="mt-3 space-y-2.5">
              {discountLevels.map((level) => (
                <article
                  key={level.label}
                  className={`relative rounded-[12px] px-3 py-3 shadow-sm ${level.tone} ${
                    level.dark ? "text-white" : "text-[#1b1b1b]"
                  }`}
                >
                  {level.badge ? (
                    <span
                      className={`absolute right-3 top-1/2 -translate-y-1/2 rounded-full px-2.5 py-1 text-[9px] font-black uppercase tracking-wide ${
                        level.dark ? "bg-primary-green text-black" : "bg-primary-green text-white"
                      }`}
                    >
                      {level.badge}
                    </span>
                  ) : null}
                  <div className="flex items-center gap-4">
                    <div
                      className={`flex h-[48px] w-[58px] shrink-0 flex-col items-center justify-center rounded-[12px] font-black ${
                        level.dark ? "bg-white/10 text-white" : "bg-[#bce9b7] text-[#303030]"
                      }`}
                    >
                      <span className="text-[1.15rem] leading-none md:text-[2rem]">{level.discount.replace("%", "")}</span>
                      <span className="text-[9px] uppercase tracking-tight">DTO</span>
                    </div>
                    <div className="text-left">
                      <p className="text-[1.05rem] font-black leading-none tracking-[0.01em] md:text-3xl">{level.label}</p>
                      <p className={`mt-1 text-[0.78rem] font-semibold leading-none md:text-lg ${level.dark ? "text-white/85" : "text-[#303030]"}`}>
                        {level.range}
                      </p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="hidden md:block">
            <div className="mx-auto max-w-[760px] text-center">
              <p className="text-[0.78rem] font-black uppercase tracking-[0.22em] text-[#65b86d]">
                Cómo funciona el descuento
              </p>
              <h2 className="mt-3 text-[3.05rem] font-semibold leading-none tracking-[-0.04em] text-[#2d2d2d]">
                Más unidades, <span className="text-primary-green">mejor precio.</span>
              </h2>
              <p className="mx-auto mt-4 max-w-[620px] text-[1.04rem] leading-[1.55] text-[#7e7e7e]">
                Las unidades se cuentan por todo lo que pidas: m² de fibra, kg de resina y botes de flakes. Todo suma.
              </p>
            </div>

            <div className="mx-auto mt-8 max-w-[528px] rounded-[8px] bg-[#eaf7e6] px-5 py-4 text-left text-[#3b3b3b]">
              <div className="border-l-[4px] border-primary-green pl-4">
                <p className="text-[0.88rem] font-black uppercase tracking-[0.14em] text-[#69b46c]">
                  Ejemplo real
                </p>
                <p className="mt-2 text-[0.98rem] leading-[1.55]">
                  8m² fibra + 4 kg resina + 4 botes flakes = 16 unidades = Nivel 2 <span className="font-semibold text-[#62b96d]">(10% dto.)</span>
                </p>
              </div>
            </div>

            <div className="mt-10 grid grid-cols-4 gap-3.5">
              {discountLevels.map((level, index) => (
                <article
                  key={level.label}
                  className={`relative min-h-[92px] rounded-[14px] px-5 py-5 ${
                    level.dark
                      ? "bg-[#121514] text-white"
                      : index === 2
                        ? "border-2 border-primary-green bg-white text-[#2a2a2a]"
                        : "bg-[#ecf8eb] text-[#2a2a2a]"
                  }`}
                >
                  {level.badge ? (
                    <span
                      className={`absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full px-3 py-1 text-[0.7rem] font-black uppercase tracking-[0.08em] ${
                        level.dark ? "bg-primary-green text-black" : "bg-primary-green text-white"
                      }`}
                    >
                      {level.badge}
                    </span>
                  ) : null}
                  <p className={`text-[2.7rem] leading-none ${level.dark ? "font-medium" : "font-semibold text-[#49a859]"}`}>
                    {level.discount}
                  </p>
                  <p className={`mt-2 text-[1.06rem] ${level.dark ? "text-white" : "text-[#353535]"}`}>
                    {level.label.replace("NIVEL ", "Nivel ")}
                  </p>
                  <p className={`mt-1 text-[0.88rem] ${level.dark ? "font-semibold text-primary-green" : "text-[#8b8b8b]"}`}>
                    {level.range.charAt(0) + level.range.slice(1).toLowerCase()}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#f3f3ef] px-4 py-4 md:hidden">
        <div className="mx-auto grid max-w-[1240px] gap-4 lg:grid-cols-[0.92fr_1.08fr]">
          <div className="rounded-[20px] bg-white px-4 py-4 shadow-sm md:rounded-[24px] md:px-8 md:py-8">
            <p className="text-[10px] font-black uppercase tracking-[0.18em] text-primary-green md:text-sm">
              Cómo funciona ser mayorista
            </p>
            <h2 className="mt-1 text-[1.75rem] font-black leading-[0.98] tracking-[-0.02em] md:text-5xl">
              Empezar es directo.
            </h2>
            <div className="mt-4 space-y-4 md:space-y-6">
              {steps.map((step) => (
                <div key={step.number} className="flex items-start gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#131313] text-[1.45rem] font-black text-primary-green md:h-12 md:w-12 md:text-[1.75rem]">
                    {step.number}
                  </div>
                  <div className="pt-0.5 text-left">
                    <h3 className="text-[0.95rem] font-semibold leading-tight text-[#151515] md:text-[2rem]">
                      {step.title}
                    </h3>
                    <p className="mt-0.5 max-w-[520px] text-[0.82rem] leading-[1.08] text-[#474747] md:text-lg">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-[20px] bg-white px-4 py-4 shadow-sm md:rounded-[24px] md:px-8 md:py-8">
            <p className="text-[10px] font-black uppercase tracking-[0.18em] text-primary-green md:text-sm">
              Qué ganas vs comprar fibra en otro lado
            </p>
            <h2 className="mt-1 text-[1.75rem] font-black leading-[0.98] tracking-[-0.02em] md:text-5xl">
              Una cuenta que crece contigo.
            </h2>
            <div className="mt-4 grid gap-2.5">
              {benefits.map((benefit) => (
                <article key={benefit.title} className="rounded-[10px] bg-[#f6f6f4] px-3 py-2.5 md:rounded-[12px] md:px-5 md:py-4">
                  <div className="flex items-start gap-3">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] bg-[#dbeed7] text-lg font-black text-[#4a8d49] md:h-11 md:w-11 md:rounded-[10px] md:text-xl">
                      {benefit.icon}
                    </div>
                    <div className="text-left">
                      <h3 className="text-[0.95rem] font-black leading-tight text-[#191919] md:text-2xl">
                        {benefit.title}
                      </h3>
                      <p className="mt-0.5 text-[0.8rem] leading-[1.08] text-[#5a5a5a] md:text-lg">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="hidden bg-white px-8 pb-12 pt-2 md:block">
        <div className="mx-auto max-w-[1430px]">
          <div>
            <p className="text-[0.8rem] font-black uppercase tracking-[0.22em] text-[#67b96d]">
              Qué ganas vs comprar en otro lado
            </p>
            <h2 className="mt-2 text-[3rem] font-semibold leading-none tracking-[-0.04em] text-[#2d2d2d]">
              Una cuenta que crece contigo.
            </h2>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4">
            {benefits.map((benefit) => (
              <article key={benefit.title} className="rounded-[16px] bg-[#f1f0eb] px-5 py-4">
                <div className="flex items-start gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-[#e7f7e7] text-[#6ab76d]">
                    <BenefitGlyph icon={benefit.icon} />
                  </div>
                  <div className="text-left">
                    <h3 className="text-[1.18rem] font-semibold leading-none text-[#424242]">
                      {benefit.title.charAt(0) + benefit.title.slice(1).toLowerCase()}
                    </h3>
                    <p className="mt-2 text-[1rem] leading-[1.45] text-[#949494]">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-9 bg-[#ebf8ea] px-6 py-8">
            <p className="text-[0.8rem] font-black uppercase tracking-[0.22em] text-[#67b96d]">
              Clientes activos
            </p>
            <h2 className="mt-2 text-[3rem] font-semibold leading-none tracking-[-0.04em] text-[#2d2d2d]">
              Talleres y fabricantes que ya compran aquí.
            </h2>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {testimonials.map((testimonial) => (
                <article
                  key={testimonial.name}
                  className="rounded-[16px] bg-white px-5 py-5 shadow-[0_1px_2px_rgba(0,0,0,0.05)]"
                >
                  <p className="text-[1rem] italic leading-[1.55] text-[#555]">{testimonial.quote}</p>
                  <div className="mt-5 flex items-center gap-3 border-t border-black/10 pt-4">
                    <div className={`flex h-10 w-10 items-center justify-center rounded-full text-[0.9rem] font-black text-white ${testimonial.color}`}>
                      {testimonial.initials}
                    </div>
                    <div>
                      <p className="text-[1.12rem] font-semibold leading-none text-[#333]">{testimonial.name}</p>
                      <p className="mt-1 text-[0.92rem] leading-none text-[#8a8a8a]">{testimonial.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white px-3 pb-6 pt-4 md:hidden">
        <div className="mx-auto grid max-w-[1240px] gap-4 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="rounded-[4px] bg-[#f2f0e8] px-4 py-4 md:rounded-[28px] md:px-8 md:py-8">
            <p className="text-[10px] font-black uppercase tracking-[0.16em] text-primary-green md:text-sm">
              Clientes activos
            </p>
            <h2 className="mt-1.5 max-w-[300px] text-[2.05rem] font-black leading-[0.95] tracking-[-0.03em] text-[#121212] md:max-w-none md:text-5xl">
              Talleres y fabricantes que ya compran aquí.
            </h2>
            <div className="mt-3 space-y-2.5">
              {testimonials.map((testimonial) => (
                <article
                  key={testimonial.name}
                  className="rounded-[8px] border border-[#b7b2a9] bg-white px-3 py-2.5 shadow-[0_1px_1px_rgba(0,0,0,0.06)] md:rounded-2xl md:px-4 md:py-4"
                >
                  <p className="text-[0.82rem] italic leading-[1.2] text-[#2f2f2f] md:text-lg">{testimonial.quote}</p>
                  <div className="mt-2.5 flex items-center gap-3 border-t border-black/10 pt-2.5">
                    <div className={`flex h-10 w-10 items-center justify-center rounded-full text-[0.95rem] font-black text-white ${testimonial.color}`}>
                      {testimonial.initials}
                    </div>
                    <div>
                      <p className="text-[0.95rem] font-black leading-none text-[#1c1c1c] md:text-2xl">{testimonial.name}</p>
                      <p className="mt-1 text-[0.78rem] leading-none text-[#666] md:text-base">{testimonial.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="px-0 py-0 md:rounded-[28px] md:bg-white md:px-8 md:py-8 md:shadow-sm">
            <h2 className="text-[2.05rem] font-black leading-[0.95] tracking-[-0.03em] text-[#111] md:text-5xl">
              Lo que más nos preguntan.
            </h2>
            <div className="mt-3 space-y-2">
              {faqs.map((item, index) => (
                <FaqAccordion key={item.title} item={item} defaultOpen={index === 0} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="hidden bg-white px-8 pb-20 pt-3 md:block">
        <div className="mx-auto max-w-[760px] text-center">
          <h2 className="text-[2.75rem] font-semibold leading-none tracking-[-0.04em] text-[#2f2f2f]">
            Lo que más nos preguntan.
          </h2>
          <div className="mx-auto mt-10 max-w-[540px] space-y-8 text-left">
            {faqs.map((item, index) => (
              <DesktopFaqItem
                key={item.title}
                item={item}
                open={desktopFaqOpenIndex === index}
                onToggle={() => setDesktopFaqOpenIndex((current) => (current === index ? -1 : index))}
              />
            ))}
          </div>

          <div className="mx-auto mt-12 max-w-[560px] rounded-[18px] border border-[#cfe8c7] bg-[#eaf7e7] px-8 py-8">
            <h3 className="text-[2.3rem] font-semibold leading-none tracking-[-0.03em] text-[#303030]">
              ¿Listo para activar tu cuenta?
            </h3>
            <p className="mt-3 text-[1.25rem] text-primary-green">
              Te contactamos en 24 horas.
            </p>
            <Link
              to="/form"
              className="mt-6 inline-flex w-full items-center justify-center rounded-[12px] bg-primary-green px-6 py-4 text-[1.22rem] font-semibold text-[#163016] transition hover:brightness-105"
            >
              Ir al formulario ↑
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 pb-10 pt-2 md:hidden">
        <div className="mx-auto max-w-[980px] text-center">
          <p className="text-sm text-[#2d2d2d] md:text-lg">
            ¿Más dudas?{" "}
            <Link to="/preguntas-frecuentes" className="font-bold text-primary-green underline">
              Ver todas las preguntas frecuentes
            </Link>
          </p>

          <div className="mt-5 rounded-[28px] border border-[#cfe8c7] bg-[#f4faef] px-5 py-6 shadow-sm md:px-8 md:py-8">
            <h2 className="text-3xl font-black leading-tight md:text-5xl">
              ¿Listo para activar tu cuenta?
            </h2>
            <p className="mt-2 text-lg text-primary-green md:text-2xl">
              Te contactamos en 24 horas.
            </p>
            <Link
              to="/form"
              className="mt-5 inline-flex w-full items-center justify-center rounded-xl bg-black px-6 py-4 text-lg font-black text-white transition hover:bg-[#191919] md:w-auto md:min-w-[360px] md:text-2xl"
            >
              Ir al formulario ↑
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Mayorista;
